import { Component, EventEmitter, Input, Output } from '@angular/core';
import { fadeInOut } from '../../shared/animations';
import { formatAttractionPrice } from '../attraction-utils';

/**
 * Bottom teaser opened by the floating button (Android `AttractionsBanner`). Tapping it goes to the
 * attractions list — it is a hook, not the destination.
 *
 * The variant is chosen by data, not by code: a real cheapest price (`attractions_from_price`) gives
 * the commercial "N tours from X" hook; otherwise it falls back to the editorial line. Pure fade
 * (via `fadeInOut`) so it reads as one crossfade with the button dissolving in place.
 */
@Component({
    selector: 'app-attractions-banner',
    templateUrl: './attractions-banner.component.html',
    styleUrls: ['./attractions-banner.component.scss'],
    animations: [fadeInOut],
    host: { class: 'attractions-scope' },
    standalone: false
})
export class AttractionsBannerComponent {
  @Input() visible = false;
  @Input() city = '';
  @Input() imageUrl: string | null = null;
  /** Raw cheapest price from the shop payload; drives the best-price variant when present. */
  @Input() fromPrice: number | null = null;
  @Input() currency: string | null = null;
  @Input() count = 0;
  @Input() bottomInset = 16;

  @Output() bannerClick = new EventEmitter<void>();
  @Output() dismiss = new EventEmitter<void>();

  get formattedPrice(): string | null {
    return formatAttractionPrice(this.fromPrice, this.currency);
  }

  onDismiss(event: Event): void {
    event.stopPropagation();
    this.dismiss.emit();
  }
}
